import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    graphContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.colors.grey_darker,
        backgroundColor: theme.colors.white,
        overflow: 'hidden',
    },

    headerWraper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        padding: `${theme.spacing(2.5)} ${theme.spacing(4)} ${theme.spacing(2)}`,
        fontFamily: theme.font.primary,
        fontSize: theme.spacing(5),
        flexWrap: 'wrap',
        flex: '0 0 auto',
    },

    headerText: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
        minWidth: 0,
        color: theme.colors.text_heading,
    },

    headerCaption: {
        fontFamily: theme.font.secondary,
        fontSize: 13,
        lineHeight: 1.4,
        color: theme.colors.grey_text,
    },

    chartSection: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        paddingBottom: theme.spacing(1),
    },

    chartContainer: {
        flex: 1,
        minHeight: 0,
        borderTopWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.colors.grey_darker,
        padding: `${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(1)} ${theme.spacing(0.5)}`,
        overflow: 'hidden',
    },

    legend: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: `${theme.spacing(1.5)} ${theme.spacing(4)} ${theme.spacing(2)}`,
        borderTop: `1px solid ${theme.colors.grey_light}`,
        backgroundColor: theme.colors.white,
        flex: '0 0 auto',
        minHeight: 56,
        maxHeight: 104,
        overflowY: 'auto',
        alignContent: 'flex-start',
        [theme.down('mobile')]: {
            flexWrap: 'nowrap',
            overflowY: 'hidden',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            overscrollBehaviorX: 'contain',
            maxHeight: 'none',
            minHeight: 48,
            alignItems: 'center',
        },
    },

    legendItem: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        minHeight: 32,
        maxWidth: '100%',
        padding: `${theme.spacing(0.75)} ${theme.spacing(1.75)}`,
        borderRadius: 999,
        border: `1px solid ${theme.colors.grey_light}`,
        backgroundColor: theme.colors.white,
        cursor: 'pointer',
        transition: 'opacity .2s ease, border-color .2s ease, background-color .2s ease',

        '&:hover': {
            borderColor: theme.colors.violet_primary,
            backgroundColor: theme.colors.tab_white,
        },
    },

    legendItemActive: {
        borderColor: theme.colors.violet_primary,
        backgroundColor: theme.colors.tab_white,
    },

    legendSwatch: {
        width: 12,
        height: 12,
        borderRadius: 999,
        flexShrink: 0,
    },

    legendLabel: {
        fontFamily: theme.font.secondary,
        fontSize: 12,
        lineHeight: 1.3,
        color: theme.colors.text_heading,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    emptyState: {
        flex: 1,
        minHeight: 240,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.colors.grey_text,
        fontFamily: theme.font.secondary,
        fontStyle: 'italic',
        borderTop: `1px solid ${theme.colors.grey_darker}`,
        padding: theme.spacing(4),
        textAlign: 'center',
    },
}));